import firebase from 'firebase';
import * as React from 'react';
import { adopt } from 'react-adopt';
import { Mutation, Query } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import Header from 'src/components/Header';
import SideBar from 'src/components/SideBar';
import TOGGLE_SIDEBAR from 'src/mutations/toggleSidebar';
import UPDATE_USER from 'src/mutations/updateUser';
import GET_SIDEBAR from 'src/queries/getSidebar';
import GET_USER from 'src/queries/getUser';
import clearLocalUser from 'src/user/clearLocalUser';
import getLocalUser from 'src/user/getLocalUser';
import signInUser from 'src/user/signInUser';

import GET_USER_PROFILE from '../queries/getUserProfile';

interface Props {
  queries: {
    getSidebar: any;
    getUser: any;
    getUserProfile: any;
  };
  mutations: {
    updateUser: any;
    toggleSidebar: any;
  };
  history: any;
}
class Shell extends React.Component<Props, {}> {
  public constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
    };
  }
  public render() {
    const { mutations, queries } = this.props;
    return (
      <SideBar
        hideSidebar={this.hideSidebar}
        history={(this.props as any).history}
        signInCreateUser={this.signInCreateUser}
        signOutUser={this.signOutUser}
        user={this.props.queries.getUser.data.user}
        visible={this.props.queries.getSidebar.data.sidebar.display}
      >
        <Header
          user={this.props.queries.getUser.data.user}
          signInCreateUser={this.signInCreateUser}
          showSidebar={this.showSidebar}
        />
        {(this.props.children as any)({ mutations, queries })}
      </SideBar>
    );
  }

  public async componentDidMount() {
    await this.signInCreateUser({ prompt: false });
    this.setState({ authenticated: true });
  }

  private signInCreateUser = async ({ prompt }) => {
    const user = await signInUser({ prompt });
    await this.props.mutations.updateUser.mutation({ variables: { user } });
    this.setState({ authenticated: true });
    this.hideSidebar(event);
  };
  private signOutUser = async (e) => {
    await firebase.auth().signOut();
    this.props.queries.getUserProfile.client.resetStore();
    (this.props as any).history.push({ pathname: "/" });
    clearLocalUser();
    this.hideSidebar(e);
  };
  private showSidebar = (event) => {
    this.props.mutations.toggleSidebar.mutation({
      variables: { display: true },
    });
  };

  private hideSidebar = (event) => {
    this.props.mutations.toggleSidebar.mutation({
      variables: { display: false },
    });
  };
}

const Compose = adopt({
  getSidebar: ({ render }) => <Query query={GET_SIDEBAR}>{render}</Query>,
  getUser: ({ render }) => <Query query={GET_USER}>{render}</Query>,
  getUserProfile: ({ getUser, render }) => (
    <Query
      query={GET_USER_PROFILE}
      variables={{ id: getUser.data.user.id, userToken: getLocalUser().token }}
      skip={!getUser.data.user.id}
    >
      {render}
    </Query>
  ),
  toggleSidebar: ({ render }) => (
    <Mutation mutation={TOGGLE_SIDEBAR}>
      {(mutation, result) => render({ mutation, result })}
    </Mutation>
  ),
  updateUser: ({ render }) => (
    <Mutation mutation={UPDATE_USER}>
      {(mutation, result) => render({ mutation, result })}
    </Mutation>
  ),
});

export default withRouter(({ children, history }) => (
  <Compose>
    {({ updateUser, getSidebar, getUser, getUserProfile, toggleSidebar }) => (
      <Shell
        history={history}
        queries={{ getSidebar, getUser, getUserProfile }}
        mutations={{ updateUser, toggleSidebar }}
      >
        {children}
      </Shell>
    )}
  </Compose>
));



// WEBPACK FOOTER //
// ./src/containers/Shell.tsx